import React, { useState, useEffect, useCallback } from 'react';
import '../styles/Hero.css';

const SLIDES = [
  {
    id: 1,
    tag:   'Pragya HR Solutions — Global Reach',
    titleParts: ['Empowering ', 'Global', ' Careers Worldwide'],
    sub:   'We bridge the gap between ambition and opportunity — making international careers accessible, efficient, and successful.',
    btn1:  { label: 'Explore Services', page: 'services' },
    btn2:  { label: 'Get Consultation', page: 'contact'  },
    img:    '/assets/1.png',
    bg:    'https://images.unsplash.com/photo-1486325212027-8081e485255e?w=1400&q=75&fit=crop',
  },
  {
    id: 2,
    tag:   'International Recruitment Excellence',
    titleParts: ['Connecting ', 'Talent', ' With Opportunity'],
    sub:   'Expert HR consultancy services tailored for individuals and organizations seeking global excellence.',
    btn1:  { label: 'Our Story',     page: 'about'   },
    btn2:  { label: 'Speak With Us', page: 'contact' },
    img:    '/assets/1.png',
    bg:    'https://images.unsplash.com/photo-1477959858617-67f85cf4f1df?w=1400&q=75&fit=crop',
  },
  {
    id: 3,
    tag:   'Visa & Immigration Support',
    titleParts: ['Your ', 'Abroad', ' Journey Begins Here'],
    sub:   'From documentation to cultural orientation — we prepare you for a successful international career journey.',
    btn1:  { label: 'View Services', page: 'services' },
    btn2:  { label: 'Start Today',   page: 'contact'  },
    img:    '/assets/1.png',
    bg:    'https://images.unsplash.com/photo-1464938050520-ef2270bb8ce8?w=1400&q=75&fit=crop',
  },
  {
    id: 4,
    tag:   'For Employers & Job Seekers',
    titleParts: ['Building ', 'Diverse', ' Global Teams'],
    sub:   'We help international companies find qualified professionals and help job seekers unlock verified global opportunities.',
    btn1:  { label: 'Find Talent', page: 'contact'  },
    btn2:  { label: 'Learn More',  page: 'services' },
    img:   '/assets/1.png',
    bg:    'https://images.unsplash.com/photo-1519501025264-65ba15a82390?w=1400&q=75&fit=crop',
  },
];

const NUMS = ['01', '02', '03', '04'];

const Hero = ({ onNavigate }) => {
  const [current, setCurrent] = useState(0);
  const [animKey, setAnimKey] = useState(0);

  const goTo = useCallback((idx) => {
    setCurrent(idx);
    setAnimKey(k => k + 1);
  }, []);

  useEffect(() => {
    const t = setInterval(() => {
      setCurrent(p => {
        const n = (p + 1) % SLIDES.length;
        setAnimKey(k => k + 1);
        return n;
      });
    }, 5500);
    return () => clearInterval(t);
  }, []);

  const slide = SLIDES[current];

  return (
    <section className="hero">

      {/* City / infrastructure background — right half */}
      <div className="hero__bg" key={`bg-${current}`}>
        <img src={slide.bg} alt="" className="hero__bg-img" aria-hidden="true" />
        <div className="hero__bg-dim" />
      </div>

      {/* Angled white/cream panel — covers left side with diagonal cut */}
      <div className="hero__panel" aria-hidden="true" />

      {/* ─── Hexagon / Diamond decorations ─── */}
      <div className="hero__deco" aria-hidden="true">
        {/* Top-left grey cluster (like Brifers) */}
        <span className="hx hx--tl-a" />
        <span className="hx hx--tl-b" />
        <span className="hx hx--tl-c" />
        <span className="hx hx--tl-d" />
        <span className="hx hx--tl-e" />
        <span className="hx hx--tl-f" />
        {/* Bottom-left gold diamonds */}
        <span className="hx hx--bl-a" />
        <span className="hx hx--bl-b" />
        <span className="hx hx--bl-c" />
      </div>

      {/* Standing person — right side, full height */}
      {/* <div className="hero__person" key={`p-${current}`}>
        <img src={slide.img} alt="HR Professional" className="hero__person-img" />
        <div className="hero__person-fade" />
      </div> */}

      {/* ─── Main content ─── */}
      <div className="hero__content" key={animKey}>
        <p className="hero__eyebrow">{slide.tag}</p>

        <h1 className="hero__heading">
          <span className="hero__heading-line">
            {slide.titleParts[0]}
            <em className="hero__heading-em">{slide.titleParts[1]}</em>
          </span>
          <span className="hero__heading-line">
            {slide.titleParts[2]}
          </span>
        </h1>

        <p className="hero__desc">{slide.sub}</p>

        <div className="hero__actions">
          <button
            className="hero__cta hero__cta--fill"
            onClick={() => onNavigate && onNavigate(slide.btn1.page)}
          >
            {slide.btn1.label}
            <span className="hero__cta-arrow">»</span>
          </button>
          <button
            className="hero__cta hero__cta--outline"
            onClick={() => onNavigate && onNavigate(slide.btn2.page)}
          >
            {slide.btn2.label}
          </button>
        </div>
      </div>

      {/* Dots */}
      <nav className="hero__dots" aria-label="Slide navigation">
        {SLIDES.map((_, i) => (
          <button
            key={i}
            className={`hero__dot${i === current ? ' is-active' : ''}`}
            onClick={() => goTo(i)}
            aria-label={`Go to slide ${i + 1}`}
          />
        ))}
      </nav>

      {/* Counter */}
      <div className="hero__counter" aria-live="polite">
        <span className="hero__counter-big">{NUMS[current]}</span>
        <span className="hero__counter-total"> / 04</span>
      </div>

    </section>
  );
};

export default Hero;